// extracted by mini-css-extract-plugin
export default {"FondGris":"FondBlanc_FondGris__yS+Ii"};